export default [
    'Central',
    'Market',
    'Both'
]
export const regionTypeEnums = Object.freeze(({'Central': 0, 'Market': 1, 'Both': 2}));